export default __webpack_public_path__ + "static/depin-d1963f7fca7cbc3043e303bd2e29235a.png";